import PropTypes from 'prop-types'
import { UserGear } from '@phosphor-icons/react'

import { getAssetLink } from '../../helpers/get-asset-link'

const SingleValue = ({ data: { avatar, label } }) => {
  return (
    <div className="on-call-schedule__custom-option">
      {avatar === 'on-call' ? (
        <UserGear size={20} />
      ) : (
        <img src={getAssetLink({ path: 'chitown-avatar/avatar', file: avatar })} />
      )}
      {label}
    </div>
  )
}

export default SingleValue

SingleValue.propTypes = {
  data: PropTypes.object.isRequired,
}
